import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AllStocks.css";
import { useNavigate, useParams } from "react-router-dom";
import { useMoreStockContext } from "../../context/MoreStockContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
const CACHE_TTL = 1000 * 60 * 10;
const TRENDING_KEY = "trending_cache";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const BASE_URL = "http://localhost:8000";

const ACTIVE_KEY = "active_cache";
const cache = {
  active: null,
  trending: null,
};

const AllStocks = () => {
  // const [activeStocks, setActiveStocks] = useState([]); // Changes for new context
  const [selectedStock, setSelectedStock] = useState(5);
  const [loading, setLoading] = useState(false);
  const [stocks, setStocks] = useState([]);
  const { data } = useMoreStockContext();
  const navigate = useNavigate();
  const { type } = useParams();
  console.log("Type", type);
  const dropDown1 = [
    { id: 1, name: "Top 5 stocks", value: 5 },
    { id: 2, name: "Top 10 stocks", value: 10 },
    // { id: 3, name: "Top 15 stocks", value: 15 },
    // { id: 4, name: "Top 20 stocks", value: 20 },
  ];

  const dropDown2 = [
    { id: 1, name: "Select Sector" },
    { id: 2, name: "Bank" },
    { id: 3, name: "IT" },
    { id: 4, name: "FMCG" },
    { id: 5, name: "Pharma" },
    { id: 6, name: "Auto" },
    { id: 7, name: "Healthcare Index" },
  ];

  // const handleRefresh = async (forceRefresh = false) => {
  //   try {
  //     setLoading(true);

  //     if (type === "active") {

  //       if (!cache.active || forceRefresh) {
  //         console.log(
  //           forceRefresh ? "Refreshing active data..." : "Fetching active..."
  //         );
  //         const res = await axios.get(`${BASE_URL}/api/most-active`);
  //         console.log("Res active data", res.data);
  //         cache.active = res.data;
  //         setActiveStocks(res.data);
  //       } else {
  //         console.log("Using cached active data");
  //         setActiveStocks(cache.active);
  //       }
  //     } else {
  //       // ✅ Trending Stocks (default)
  //       if (!cache.trending || forceRefresh) {
  //         console.log(
  //           forceRefresh
  //             ? "Refreshing trending data..."
  //             : "Fetching trending..."
  //         );
  //         const res = await axios.get(`${BASE_URL}/api/trending`);
  //         cache.trending = res.data.trending_stocks;
  //         setStocks(res.data.trending_stocks);
  //       } else {
  //         console.log("Using cached trending data");
  //         setStocks(cache.trending);
  //       }
  //     }
  //   } catch (error) {
  //     console.error(`Error fetching ${type} data:`, error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   handleRefresh();
  // }, [type]);

  // const handleManualRefresh = async () => {
  //   await handleRefresh(true);
  // };

  // console.log("Active stock Data:-", activeStocks);
  // console.log("Trending Data", stocks?.top_gainers);

  // let limitedStocks =
  //   selectedStock > 0 ? activeStocks.slice(0, selectedStock) : [];
  let limitedStocks = selectedStock > 0 ? data.slice(0, selectedStock) : [];

  let gainerStocks = [];
  let loserStocks = [];

  // gainerStocks = stocks?.top_gainers || [];
  // gainerStocks =
  //   selectedStock > 0 ? stocks?.top_gainers?.slice(0, selectedStock) : [];
  gainerStocks = selectedStock > 0 ? data?.slice(0, selectedStock) : []; // New code using context data

  // loserStocks = stocks?.top_losers || [];
  // loserStocks =
  //   selectedStock > 0 ? stocks?.top_losers?.slice(0, selectedStock) : [];
  loserStocks = selectedStock > 0 ? data?.slice(0, selectedStock) : [];

  console.log("Gainers", gainerStocks);
  console.log("loosers", loserStocks);
  let dataToRender = [];

  if (type === "active") {
    dataToRender = limitedStocks;
  } else if (type === "gainers") {
    dataToRender = gainerStocks;
    // dataToRender = data;
  } else if (type === "losers") {
    dataToRender = loserStocks;
  }

  console.log("Limited", limitedStocks);
  console.log("Data", dataToRender);
  // const options =
  //   type === "active"
  //     ? dropDown1
  //     : [{ id: 0, name: "All Stocks", value: 0 }];
  const options = dropDown1;
  const formatVolume = (volume) => {
    return typeof volume === "string"
      ? Number(volume).toLocaleString()
      : volume.toLocaleString();
  };
  console.log("Context data", data);

  return (
    <>
      <div className="all-stocks">
        {/* <div style={{ textAlign: "right", margin: "10px" }}>
          <button
            className="rec-btn"
            onClick={handleManualRefresh}
            disabled={loading}
          >
            {loading ? "Refreshing..." : "Refresh Data"}
          </button>
        </div> */}
        <div
          className="dropdown"
          style={{ display: "flex", justifyContent: "center", gap: "3rem" }}
        >
          <select onChange={(e) => setSelectedStock(Number(e.target.value))}>
            {options.map((item) => (
              <option value={item.value} key={item.id}>
                {item.name}
              </option>
            ))}
          </select>

          <select name="" id="">
            {dropDown2.map((item, id) => (
              <option value={item.name} key={item.id}>
                {item.id === 1 ? "" : "Nifty"} {item.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <h1 className="all-stock-head">
            {type === "gainers"
              ? "Top Gainers"
              : type === "losers"
              ? "Top Losers"
              : "Top Most Active"}
          </h1>
          <div className="stock-table-container">
            <table className="stock-table">
              <thead>
                <tr>
                  <th>Company or Ticker</th>
                  <th>Price</th>
                  <th>Open</th>
                  <th>Close</th>
                  <th>% Change</th>
                  <th>Low</th>
                  <th>High</th>
                  <th>Volume</th>
                  <th>Recommendation</th>
                </tr>
              </thead>
              <tbody>
                {dataToRender?.map((stock) => (
                  <tr key={stock.ticker_id} className="stock-row">
                    <td>
                      {type === "gainers" || type === "losers"
                        ? `${stock.company_name} (${stock.ric})`
                        : `${stock.company} (${stock.ticker})`}
                    </td>
                    <td>₹{stock.price}</td>
                    <td>₹{stock.open}</td>
                    <td>₹{stock.close}</td>

                    <td
                      style={{
                        color:
                          stock.percent_change >= 0 ? "#249966" : "#f87171",
                        fontWeight: "bold",
                      }}
                    >
                      {stock.percent_change}%
                    </td>
                    <td>₹{stock.low}</td>
                    <td>₹{stock.high}</td>
                    <td>{formatVolume(stock.volume)}</td>
                    <td>
                      <button
                        // className="rec-btn"
                        className={`${
                          type === "gainers"
                            ? "rec-btn"
                            : type === "losers"
                            ? "rec-btn"
                            : "trade-btn"
                        }`}
                        onClick={() =>
                          type === "active"
                            ? navigate(`/stockdetail/${stock.company}`)
                            : type === "losers"
                            ? navigate(`/stockdetail/${stock.company}`)
                            : navigate(`/stockdetail/${stock.company_name}`)
                        }
                        style={{
                          backgroundColor:
                            type === "gainers"
                              ? "#249966"
                              : type === "losers"
                              ? "#f87171"
                              : "",
                        }}
                      >
                        {type === "gainers"
                          ? "Buy"
                          : type === "losers"
                          ? "Sell"
                          : "Trade"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* <div
              className="market-cards"
              style={{ display: "flex", margin: "1rem auto" }}
            >
              <div className="market-card">
                <div className="market-card-title">
                  <h2 className="card-title">
                    Top{" "}
                    {type === "gainers"
                      ? "Gainers"
                      : type === "losers"
                      ? "Losers"
                      : type === "active"
                      ? "Active"
                      : ""}
                  </h2>

                  <IoMdTrendingUp style={{ color: "#249966 " }} />
                </div>

                {dataToRender?.map((stock) => (
                  <div className="card-row" key={stock.ticker_id}>
                    <div className="left">
                      <p className="name">
                        {type === "gainers" || type === "losers"
                          ? `${stock.company_name} )`
                          : `${stock.company} )`}
                      </p>
                      <p className="price">₹{stock.price}</p>
                    </div>

                    <div className="right">
                      <p
                        className="change"
                        style={{
                          color:
                            stock.percent_change > 0 ? "#249966" : "#f87171",
                        }}
                      >
                        +
                        {stock.percent_change > 0
                          ? +`${stock.percent_change}`
                          : `${stock.percent_change}`}
                        %
                      </p>
                      <button
                        className="buy-btn"
                        onClick={() =>
                          type === "active"
                            ? navigate(`/stockdetail/${stock.company}`)
                            : navigate(`/stockdetail/${stock.company_name}`)
                        }
                      >
                        {type === "gainers"
                          ? "Buy"
                          : type === "losers"
                          ? "Sell"
                          : type === "active"
                          ? "Trade"
                          : ""}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllStocks;
